export default "__VITE_ASSET__09ba08a2__"